
import { useEffect, useState } from "react";

const ServicesComponent = ({ data }) => {
    const [services, setServices] = useState(data?.businessProductCat || []);

    useEffect(() => {
        setServices(data?.businessProductCat || [])
    }, [data])

    return (
        <div className="uploadbannerblmdiv">
            <div className="uploadbannerdivnewmain">
                <div className="consttactdetatlsarroedyrdiv">
                    <p className="cinnattddttdtsttspo">Services</p>
                </div>
                <div className="adversytfservicexedib">
                    {services?.map((item, index) => (
                        <div
                            key={index}
                            style={{
                                display: "flex",
                                alignItems: "center",
                                marginLeft: "10px",
                                // backgroundColor: "silver",
                                padding: "5px 10px",
                                borderRadius: "15px",
                            }}
                        >
                            <p style={{ color: "#000", fontWeight: "500" }}>{item}</p>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
}
export default ServicesComponent;